"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../../..");
var DatePicker_1 = __importDefault(require("../../DatePicker/DatePicker"));
var Field_1 = __importDefault(require("../components/Field"));
var Label_1 = __importDefault(require("../components/Label"));
var DateField = function (_a) {
    var name = _a.name, label = _a.label, size = _a.size, readOnly = _a.readOnly, minDate = _a.minDate, maxDate = _a.maxDate, defaultValue = _a.defaultValue, toolTip = _a.toolTip, defValue = _a.defValue, clearIcon = _a.clearIcon, setValue = _a.setValue, defaultActiveStartDate = _a.defaultActiveStartDate, setToLocal = _a.setToLocal;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    react_1.useEffect(function () {
        if (defValue)
            helpers.setValue(defValue.value);
    }, [defValue === null || defValue === void 0 ? void 0 : defValue.value]);
    react_1.useEffect(function () {
        if (minDate) {
            if (minDate && field.value && new Date(field.value).toISOString() < minDate.toISOString()) {
                helpers.setValue(minDate.toISOString());
                if (setValue)
                    setValue(minDate.toISOString());
            }
        }
    }, [minDate]);
    var handleChange = function (d) {
        if (d === null) {
            helpers.setValue(undefined);
            if (setValue)
                setValue(undefined);
            if (setToLocal)
                setToLocal(name, undefined);
        }
        else {
            var x = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            x.setFullYear(d.getFullYear());
            helpers.setValue(x.toISOString());
            if (setValue)
                setValue(x.toISOString());
            if (setToLocal)
                setToLocal(name, x.toISOString());
        }
    };
    return (react_1.default.createElement(Field_1.default, null,
        label && react_1.default.createElement(Label_1.default, { htmlFor: __1.NormalizeString(name) }, label),
        react_1.default.createElement(__1.Tooltip, { content: toolTip, disabled: !toolTip },
            react_1.default.createElement("div", null,
                react_1.default.createElement(DatePicker_1.default, { onChange: handleChange, defaultValue: defaultValue, value: field.value, name: name, size: size, readOnly: readOnly, minDate: minDate, maxDate: maxDate, clearIcon: readOnly ? null : clearIcon, hasError: !!meta.error, defaultActiveStartDate: defaultActiveStartDate })))));
};
DateField.defaultProps = {
    size: undefined,
    readOnly: false,
    minDate: undefined,
    maxDate: undefined,
    defaultValue: undefined,
    toolTip: undefined,
    defValue: undefined,
    label: undefined,
    clearIcon: undefined,
    setValue: undefined,
    defaultActiveStartDate: undefined,
    setToLocal: undefined,
};
exports.default = DateField;
